import { omitKeys } from "@hex-insights/core";
import { Contract, ContractInstallment } from "../../../Utilities";

export type Base = {
	dueDate: ContractInstallment["dueDate"] | null;
	portion: ContractInstallment["portion"] | null;
	contractID: Contract["id"] | null;
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, "dueDate" | "contractID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	dueDate: null,
	portion: 1, // customized
	contractID: null,
};

export type Detail = Base;

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export type CreateInContract = Omit<Create, "contractID">;

export type CreateInContractRequiredKey = Exclude<CreateRequiredKey, "contractID">;

export type CreateInContractSubset<K extends keyof CreateInContract = keyof CreateInContract> = Pick<
	CreateInContract,
	CreateInContractRequiredKey | K
>;

export const blankItemInContract: CreateInContract = omitKeys(initialCreate, ["contractID"]);
